import { getAssistantsList } from "@/apis/assistants/index";
export const assistantsModule = {
  namespaced: true,
  state: () => ({
    assistants: []
  }),
  mutations: {
    getAssistants(state, payload) {
      state.assistants = payload.results;
    }
  },
  actions: {
    actionGetAssistantsList({ commit }) {
      return getAssistantsList().then(res => {
        commit("getAssistants", res.data);
        return res;
      });
    }
  }
};
